import { useMemo } from 'react';
import { buildCapabilitiesFromConfig } from './utils/buildCapabilitiesFromConfig';
import useDebounce from './utils/useDebounce';
import styled from 'styled-components';
import UIFlex from 'UIComponents/layout/UIFlex';
import { SubmitButtonContext } from './contexts/SubmitButtonContext';
import { EditorConfigContext } from './contexts/EditorConfigContext';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledWrapper = styled.div.withConfig({
  displayName: "ProsemirrorMenu__StyledWrapper",
  componentId: "sc-1m24mtu-0"
})(["padding-top:8px;"]);
export const ProsemirrorControls = styled(UIFlex).withConfig({
  displayName: "ProsemirrorMenu__ProsemirrorControls",
  componentId: "sc-1m24mtu-1"
})(["align-items:center;flex-wrap:wrap;"]);
export default function ProsemirrorMenu(props) {
  const {
    editorConfig,
    menuClassName = '',
    submitButton
  } = props;
  const memoizedSubmitButton = useMemo(() => {
    return {
      submitButton
    };
  }, [submitButton]);
  const debouncedEditorConfig = useDebounce(editorConfig, 50);
  const toolbarCapabilities = useMemo(() => {
    return buildCapabilitiesFromConfig(editorConfig);
  }, [editorConfig]);
  return /*#__PURE__*/_jsx(StyledWrapper, {
    className: `prosemirror-controls ${menuClassName}`,
    children: /*#__PURE__*/_jsx(EditorConfigContext.Provider, {
      value: debouncedEditorConfig,
      children: /*#__PURE__*/_jsx(SubmitButtonContext.Provider, {
        value: memoizedSubmitButton,
        children: /*#__PURE__*/_jsx(ProsemirrorControls, {
          children: toolbarCapabilities
        })
      })
    })
  });
}